import { config } from 'config';
import i18n from 'i18nextInstance';

const {
    absenceReport,
    asyncConsults,
    consult,
    diagnosisAudits,
    interconsult,
    recipes,
    recipesRequests,
    turns,
    turnsCoverage,
    turnsPayment
} = config;

export const adminLockedActions = [{
    key: 'show_profile',
    labelAction: i18n.t('Mostrar en los listados del paciente')
}, {
    key: 'online_attention',
    labelAction: i18n.t('Atención online'),
    visible: turns
}, {
    key: 'presential_attention',
    labelAction: i18n.t('Atención presencial'),
    visible: turns
}, {
    key: 'async_attention',
    labelAction: i18n.t('Recibir mensajes'),
    visible: asyncConsults
}, {
    key: 'create_recipe',
    labelAction: i18n.t('Crear y cancelar recetas'),
    visible: recipes
}, {
    key: 'videocall_platform',
    labelAction: i18n.t('Utilizar la plataforma para videollamadas')
}, {
    key: 'online_click_to_call',
    labelAction: i18n.t('Permitir recibir llamadas si se encuentra disponible'),
    visible: consult
}, {
    key: 'validate_mercadopago',
    labelAction: i18n.t('Validar llamadas por Mercadopago'),
    visible: turnsPayment
}, {
    key: 'validate_coverage',
    labelAction: i18n.t('Validar llamadas por cobertura'),
    visible: turnsCoverage
}, {
    key: 'agenda_edit',
    labelAction: i18n.t('Editar y eliminar agendas'),
    visible: turns
}, {
    key: 'unavailable_edit',
    labelAction: i18n.t('Agregar y eliminar días no disponibles'),
    visible: turns
}, {
    key: 'diagnosis_audits',
    labelAction: i18n.t('Agregar y vizualizar auditorias'),
    visible: diagnosisAudits
}, {
    key: 'absence_report',
    labelAction: i18n.t('Recibir informes de ausentismo'),
    visible: absenceReport
}, {
    key: 'recipe_requests',
    labelAction: i18n.t('Recibir solicitudes de receta'),
    visible: recipesRequests
}].filter(({ visible = true }) => visible);

export const configActions = [{
    isLockedAction: false,
    key: 'receive_patients_calls',
    labelAction: i18n.t('Recibir pacientes')
}, {
    isLockedAction: false,
    key: 'receive_interconsults_calls',
    labelAction: i18n.t('Recibir interconsultas'),
    visible: interconsult
}, {
    isLockedAction: false,
    key: 'receive_appointments',
    labelAction: i18n.t('Recibir turnos'),
    visible: turns
}].filter(({ visible = true }) => visible);
